import { render, staticRenderFns } from "./StrapiConfidentialiteView.vue?vue&type=template&id=326b7f05"
import script from "./StrapiConfidentialiteView.vue?vue&type=script&lang=js"
export * from "./StrapiConfidentialiteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports